import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import { getData } from "../../../utils/api";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    clearErrors,
  } = useForm();
  const imageFile = watch("image");


   const [imagePreview, setImagePreview] = useState(null); // State to store image preview
  const [socialLinks, setSocialLinks] = useState([]);
  const [selectedSocials, setSelectedSocials] = useState([]);
  const [socialUrls, setSocialUrls] = useState({});

  useEffect(() => {
  const getSocialLinks = async () => {
    const response = await getData("/admin/setting/social-link", {});

    if (response?.success) {
      const options =
        response?.data?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];

      setSocialLinks(options);
    }
  };

  getSocialLinks();
}, []);

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      finalData.append("name", data.name);
      finalData.append("title", data.title);

      if (data.image?.length) {
        finalData.append("image", data.image[0]);
      }

      const socialIds = selectedSocials.map((item) => item.value);

      finalData.append("social_id", JSON.stringify(socialIds));
      finalData.append("social_url", JSON.stringify(socialUrls));

      const response = await postData("/admin/setting/expert-team", finalData);

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });

        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
      clearErrors("image");
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Expert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Expert Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Expert Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Expert Name is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Title</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="title"
                        placeholder="Title"
                        className={classNames("", {
                          "is-invalid": errors?.title,
                        })}
                        {...register("title", {
                          required: "Expert Title is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.title && (
                      <span className="text-danger">{errors.title.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="image"
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  {imagePreview && (
                    <div className="mt-2">
                      <img
                        src={imagePreview}
                        alt="Category Preview"
                        style={{ maxWidth: "100px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Social Links</Form.Label>

                  <Select
                    options={socialLinks}
                    isMulti
                    value={selectedSocials}
                    onChange={(selected) => setSelectedSocials(selected || [])}
                    placeholder="Select Social Links"
                  />
                </div>
              </Col>

              {selectedSocials.map((item) => (
                <Col md={6} key={item.value}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <Form.Label>{item.label} URL</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder={`Enter ${item.label} URL`}
                        value={socialUrls[item.value] || ""}
                        onChange={(e) =>
                          setSocialUrls({
                            ...socialUrls,
                            [item.value]: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </div>
                </Col>
              ))}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
